import React, {PropTypes} from 'react'
import {Col, Row, Button, OverlayTrigger, Popover} from 'react-bootstrap'
import showToastr from '../../utils/showToastr'
import {Actions} from 'jumpstate'
import SocialShareComponent from '../Common/SocialShare/SocialShareComponent'
import {MdShare} from '../Common/ReactIcons/icons'
import './Layout/AdsDetails.css'
import { PersianNumber } from 'react-persian'

class AdDetails extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      ad: this.props.info,
      link: this.props.link,
      isNumberBoxVisible: false
    }

    this.numberHandler = this.numberHandler.bind(this)
  }

  componentWillReceiveProps (nextProps) {
    this.setState({ad: nextProps.info})
  }

  numberHandler (show = true) {
    const {auth} = this.props
    if (!auth.isAuthenticated) {
      showToastr('warning', '', 'لازم است به حساب خود وارد شوید')
      Actions.toggleLoginBox(true)
      return undefined
    }
    this.setState({isNumberBoxVisible: show})
  }

  render () {
    const {ad, isNumberBoxVisible, link} = this.state

    return (
      <Row className="Ad Box">
        <Col xs={12}>
          <Row>
            <Col xs={7}><Button bsStyle="primary" onClick={() => this.setState({isNumberBoxVisible: true})}>نمایش اطلاعات تماس</Button></Col>
            <Col xs={5} className="LeftButton">
              <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={<Popover id={`popoverShareAd`} title="با دوستانتان به اشتراک بگذارید.">
                <SocialShareComponent
                  url={link}
                  title={`${ad.type} ${ad.horse.name}`}
                  description={ad.description ? ad.description : ''} />
              </Popover>}>
                <Button bsStyle="danger"><MdShare /> اشتراک</Button>
              </OverlayTrigger>
            </Col>
          </Row>
          {isNumberBoxVisible && <Row className="Info TopBox">
            <Col xs={6}>شماره تماس</Col>
            <Col xs={6} className="TextBold"><PersianNumber>{ad.phone}</PersianNumber></Col>
          </Row>}
          <Row className="Info TopBox">
            <Col xs={6}>آگهی دهنده</Col>
            <Col xs={6} className="TextBold">{ad.user.name ? ad.user.name : ad.user.username}</Col>
          </Row>
          <Row className="Info TopBox">
            <Col xs={6}>نوع آگهی</Col>
            <Col xs={6} className="TextBold">{AdDetails.translateAdType(ad.type)}</Col>
          </Row>
          <Row className="Info TopBox">
            <Col xs={6}>قیمت</Col>
            {ad.price > 0 ? <Col xs={6} className="TextBold"><PersianNumber>{parseInt(ad.price, 10).toLocaleString()}</PersianNumber> <span>تومان</span></Col> : <Col xs={6} className="TextBold">توافقی</Col>}
          </Row>
          {ad.description && <Row className="Info TopBox">
            <Col xs={12} className="DescriptionBold">{ad.description}</Col>
          </Row>}
        </Col>
      </Row>
    )
  }
}

AdDetails.translateAdType = (type) => {
  switch (type) {
    case 'mate': return 'کشش'
    case 'sale': return 'فروش'
    case 'belly-rental': return 'اجاره شکم'
    default: return ''
  }
}

AdDetails.propTypes = {
  info: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired
}

export default AdDetails



// WEBPACK FOOTER //
// ./src/components/Ad/AdDetails.js